import { BASEURL } from "../BaseUrl";

/**
 * Fetches Postgres Tables based on the Postgres Schemas.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {string} schema - The date parameter to filter tables.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getOracleTables = async (axios, schema) => {
  return await axios.get(`${BASEURL}/power_bi/tables`, {
    params: {
      schemaName: schema,
    },
  });
};

const getOracleColumns = async (axios, schema, table) => {
  return await axios.get(`${BASEURL}/power_bi/columns`, {
    params: {
      schemaName: schema,
      tableName: table,
    },
  });
};

export const OracleApi = {
  getOracleTables,
  getOracleColumns,
};
